import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

// style.ts
import { SxProps, Theme } from '@mui/material/styles';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const buttonStyles: { button: SxProps<Theme> } = {
  button: {
    py: getResponsiveSize(12),
    px: getResponsiveSize(16),
    height: getResponsiveSize(46),
    fontSize: theme.typography.fs19,
    lineHeight: getResponsiveSize(22),
    textTransform: 'none',
    borderRadius: theme.palette.propVars.borderRadius,

    // ⛔️ was: ...theme.palette.propVars.btnBoxShadow
    // ✅ do:
    boxShadow: theme.palette.propVars.btnBoxShadow,

    // ⛔️ was: ...theme.palette.propVars.semiBoldFontWeight
    // ✅ do:
    fontWeight: theme.palette.propVars.semiBoldFontWeight,

    backgroundSize: '200%',
    backgroundPosition: 'right bottom',
    transition: '.45s background cubic-bezier(0.4, 0, 0.2, 1), .4s box-shadow cubic-bezier(0.4, 0, 0.2, 1)',

    '&.Mui-disabled': { opacity: 0.5 },

    '&.primaryBtn': {
      backgroundImage: `linear-gradient(to left, ${theme.palette.myPrimary.lightBlue100} 50%, ${theme.palette.myPrimary.darkBlue100} 50%)`,
      color: theme.palette.myPrimary.white,
      '&:hover': {
        backgroundPosition: 'left bottom',
        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.15)',
      },
      '&:active': { boxShadow: 'none' },
      '&.Mui-disabled': { background: theme.palette.myPrimary.lightBlue100 },
    },

    '&.secondaryBtn': {
      backgroundImage: `linear-gradient(to left, transparent 50%, ${theme.palette.myPrimary.lightBlue40} 50%)`,
      border: `1px solid ${theme.palette.myPrimary.lightBlue100}`,
      color: theme.palette.myPrimary.lightBlue100,
      '&:hover': { backgroundPosition: 'left bottom' },
      '&:active': { color: theme.palette.myPrimary.lightBlue100 },
      '&.Mui-disabled': { backgroundColor: 'transparent' },
    },

    '&.inputBtn': {
      backgroundColor: theme.palette.myPrimary.lightBlue100,
      backgroundImage: `linear-gradient(to left, ${theme.palette.myPrimary.lightBlue70} 50%, ${theme.palette.myPrimary.lightBlue100} 50%)`,
      color: theme.palette.myPrimary.white,
      '&:hover': { backgroundPosition: 'left bottom' },
      '&.Mui-disabled': { background: theme.palette.myPrimary.lightBlue100 },
    },
  },
};
